import { createPortal } from 'react-dom';

import type { DragCursor } from '../../utilities/resizeCursor';
import { zIndexes } from '../../common/z_indexes';
import { styled } from '../../stitches.config';

const Shield = styled('div', {
  position: 'fixed',
  inset: 0,
  zIndex: zIndexes.cursorShield,
});

export function ResizeCursorShield({ cursor }: { cursor: DragCursor | null }) {
  if (cursor === null) {
    return null;
  }

  return createPortal(<Shield style={{ cursor }} />, document.body);
}
